import useLanguages from "hooks/useLanguages";
import { Helmet } from "react-helmet-async";
import { ProviderUtils } from "utils/providerUtils";

const PRIMARY_SITE_URL = "https://ktx.lacha.co.kr/";
const NOINDEX_HOSTNAMES = ["card.lacha.co.kr"];

const Metatag = () => {
  const { isKorean } = useLanguages();

  const title = isKorean ? "라차" : "Lacucaracha";
  const description = isKorean
    ? "라차에서 KTX 할인받고 편리하게 여행하세요."
    : "With Lacha, get KTX discounts and travel conveniently.";
  const hostname = window.location.hostname;
  const shouldHideFromSearch =
    hostname === "hcclab.co.kr" ||
    hostname.endsWith(".hcclab.co.kr") ||
    NOINDEX_HOSTNAMES.includes(hostname);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {shouldHideFromSearch && <meta name="robots" content="noindex, follow" />}

      <link rel="canonical" href={PRIMARY_SITE_URL} />
      <meta property="og:url" content={PRIMARY_SITE_URL} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content={title} />
      <meta property="og:description" content={description} />

      <meta name="twitter:url" content={PRIMARY_SITE_URL} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:site_name" content={title} />
      <meta name="twitter:description" content={description} />

      {/* card에서만 manifest.json 불러오기 */}
      {ProviderUtils.isCard && (
        <link rel="manifest" href={`${process.env.PUBLIC_URL}/manifest.json`} />
      )}
    </Helmet>
  );
};

export default Metatag;
